import React, { useState } from 'react';
import './ObjectiveTracker.css';

const TOTAL_HOUSES = 4;

const PROGRESS_COLORS = [
  '#ef4444', // 0/4 — red
  '#f97316', // 1/4 — orange
  '#eab308', // 2/4 — yellow
  '#84cc16', // 3/4 — lime
  '#22c55e', // 4/4 — green
];

interface ObjectiveTrackerProps {
  visitedCount: number;
}

export const ObjectiveTracker: React.FC<ObjectiveTrackerProps> = ({ visitedCount }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const progress = Math.min(visitedCount, TOTAL_HOUSES);
  const pct = (progress / TOTAL_HOUSES) * 100;
  const color = PROGRESS_COLORS[progress];
  const done = progress >= TOTAL_HOUSES;

  if (dismissed) return null;

  return (
    <div className={`objective-tracker${done ? ' completed' : ''}${collapsed ? ' collapsed' : ''}`}>
      <div className="objective-box">
        <div className="objective-header">
          <div className="objective-label">Objective</div>
          {done ? (
            <button
              className="objective-close-btn"
              onClick={() => setDismissed(true)}
              title="Dismiss"
            >
              &times;
            </button>
          ) : (
            <button
              className="objective-collapse-btn"
              onClick={() => setCollapsed(!collapsed)}
              title={collapsed ? 'Expand' : 'Collapse'}
            >
              {collapsed ? '+' : '\u2013'}
            </button>
          )}
        </div>

        <div className="objective-content">
          <p className="objective-text">
            {done
              ? 'You visited every house \u2014 nice work!'
              : 'Visit all the houses to learn more about Wesley!'}
          </p>
          <div className="objective-progress-track">
            <div
              className="objective-progress-fill"
              style={{ width: `${pct}%`, backgroundColor: color }}
            />
          </div>
          <div className="objective-count" style={{ color }}>
            {progress} / {TOTAL_HOUSES}
          </div>
        </div>

      </div>
    </div>
  );
};
